// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smallModalCorporateSession {
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    margin-left: 0px;
    z-index: 999;
}

.smallModal {
    display: flex;
    justify-content: center;
    position: relative;
    flex-direction: column;
    max-width: 378px;
    min-width: 270px;
    min-height: 150px;
    background-color: white;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    z-index: 999;
    text-align: start;
    border-top: 6px solid #007bc0;
}

.titleSmallModal {
    font-size: 16px;
    font-weight: 600;
}

.buttonsEdit {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: 15px;
    margin-bottom: 15px;
    gap: 25px;
}

.containerTitleSmallModal {
    padding: 5px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #c1c7cc;
}

.containerDescription {
    padding: 5px 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.bodySmallModal {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    font-size: 15px;
    margin-top: 25px;
}

button .buttonGeneric .buttonHover:hover {
    background-color: #00629a;
    color: #fff;
}

button.buttonGeneric.buttonHover {
    background-color: #007bc0;
    color: #fff;
}

.lineLabelSmallInput {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/componentes/ModalGeneric/modalGeneric.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,+CAA+C;IAC/C,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".smallModalCorporateSession {\n    display: flex;\n    position: fixed;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    margin-left: 0px;\n    z-index: 999;\n}\n\n.smallModal {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    flex-direction: column;\n    max-width: 378px;\n    min-width: 270px;\n    min-height: 150px;\n    background-color: white;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n    z-index: 999;\n    text-align: start;\n    border-top: 6px solid #007bc0;\n}\n\n.titleSmallModal {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.buttonsEdit {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    padding-top: 15px;\n    margin-bottom: 15px;\n    gap: 25px;\n}\n\n.containerTitleSmallModal {\n    padding: 5px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #c1c7cc;\n}\n\n.containerDescription {\n    padding: 5px 25px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.bodySmallModal {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    font-size: 15px;\n    margin-top: 25px;\n}\n\nbutton .buttonGeneric .buttonHover:hover {\n    background-color: #00629a;\n    color: #fff;\n}\n\nbutton.buttonGeneric.buttonHover {\n    background-color: #007bc0;\n    color: #fff;\n}\n\n.lineLabelSmallInput {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
